module.exports = __webpack_public_path__ + "img/qiye.ba890b92.png";